import axios from "axios";
import { setHeaders } from "../axiosInterceptors";

// Axios instance
const axiosInstance = axios.create();

setHeaders(axiosInstance);

export default axiosInstance;
